import React, { useState } from 'react';
import { useRiskResults } from '@/features/health/hooks/useRiskResults';
import ScrollToTopButton from "@/widgets/ButtonTop/ButtonTop";
import { useHealthResults } from '@/features/health/hooks/useHealthResults';

export const HealthRecommendationsPage: React.FC = () => {
    const { data: risks, loading } = useRiskResults();
    const [showDetails, setShowDetails] = useState(false);

    const toggleDetails = () => setShowDetails(prev => !prev);

    const health = useHealthResults();

    const levelOrder = ['very_low', 'below_normal', 'normal', 'above_average', 'high'];

    const getLevelClass = (level: string) => {
        const map: Record<string, string> = {
            very_low: 'very-low',
            below_normal: 'low',
            normal: 'medium',
            above_average: 'high',
            high: 'very-high',
        };
        return map[level] || '';
    };

    const getTagClass = (level: string) => {
        switch (level) {
            case 'high': return 'risk-card__tag risk-card__tag_high';
            case 'middle':
            case 'medium': return 'risk-card__tag risk-card__tag_middle';
            case 'low': return 'risk-card__tag risk-card__tag_low';
            default: return '';
        }
    };

    console.log(risks)
    return (
        <>
            <main className="layout__content">

                <section className="section layout__section test-results">
                    <div className="container">
                        <div className="section__content">
                            <div className="test-results__intro test-results-intro">
                                <div className="test-results-intro__inner">
                                    <div className="test-results-intro__left">
                                        <h1 className="title test-results__title"></h1>
                                        <span className="test-results__health-level test-results-health-level">
              Твой уровень здоровья:
              <span className="test-results-health-level__value" style={{ color: health?.iconFill}}>
                {health?.healthStatus}
              </span>
            </span>
                                        <p className="test-results__description">
                                            {health?.descTest}
                                        </p>
                                    </div>
                                    <div className="test-results-intro__right">
                                        <div className="test-results-intro__health-emotion-wrapper">
                                            {health && (
                                                <div className="health-emotion test-results__health-emotion">
                                                    <svg className="svg-icon" style={{ fill: health.iconFill }}>
                                                        <use href={`/img/sprite-health-emotions.svg#${health.icon}`} />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="health-bar test-results__health-bar">
                                <div className="health-bar__levels">
                                    {levelOrder.map(level => {
                                        const cssClass = getLevelClass(level);
                                        const isCurrent = cssClass === health?.color;

                                        return (
                                            <div
                                                key={level}
                                                className={`health-bar__level health-bar-level health-bar-level_${cssClass} ${isCurrent ? 'health-bar-level_current' : ''}`}
                                            >
                                                <div className="health-bar-level__line"></div>
                                                <span className="health-bar-level__label">
                  {{
                      high: 'Высокий',
                      above_average: 'Выше среднего',
                      normal: 'Нормальный',
                      below_normal: 'Ниже нормы',
                      very_low: 'Очень низкий',
                  }[level]}
                </span>
                                                {isCurrent && (
                                                    <div className="marker health-bar-level__marker">
                                                        <span className="marker__label">Вы сейчас здесь</span>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="health-bar__legend">
                                    <div className="health-bar__legend-item health-bar-legend-item health-bar-legend-item_very-low">
                                        Очень низкий
                                    </div>
                                    <div className="health-bar__legend-item health-bar-legend-item health-bar-legend-item_low">
                                        Ниже нормы
                                    </div>
                                    <div className="health-bar__legend-item health-bar-legend-item health-bar-legend-item_medium">
                                        Нормальный
                                    </div>
                                    <div className="health-bar__legend-item health-bar-legend-item health-bar-legend-item_high">
                                        Выше среднего
                                    </div>
                                    <div className="health-bar__legend-item health-bar-legend-item health-bar-legend-item_very-high">
                                        Высокий
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section layout__section risks">
                    <div className="container">
                        <header className="section__header risks__header">
                            <h2 className="title section__title risks__title risks-title">
                                <span className="risks-title__indicator">!</span>
                                Твои риски
                            </h2>
                            <p className="risks-intro__description">
                                Мы проанализировали ваши ответы и сделали вывод, какие риски конкретных заболеваний у вашего организма наиболее высокие.
                            </p>
                        </header>
                        <div className="section__content">
                            <div className="risks-cards__grid">
                                {loading ? <p>Загрузка...</p> : risks.map(risk => (
                                    <div className="risks-cards__col" key={risk.id}>
                                        <div className="risk-card risk-card_flex">
                                            <div className="risk-card__left">
                                                <img className="svg-icon risk-card__icon" src={risk.icon} />
                                                <h6 className="risk-card__title">{risk.title}</h6>
                                            </div>
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                <span style={{ color: '#7E7E7E', fontWeight: '400'}}>Риск</span>
                                                <div className={getTagClass(risk.level)}>

                                                    {risk.level === 'high' ? 'Высокий' : risk.level === 'middle' ? 'Средний' : 'Низкий'}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="risks-intro__more risks-intro__more_new risks-intro__more_desktop">
                                <div className="button button_link" onClick={toggleDetails}>
                                    <span className="button__label">{showDetails ? 'Свернуть' : 'Подробнее'}</span>
                                    <svg className="svg-icon button__icon">
                                        <use href={`/img/sprite-icons.svg#arrow-${showDetails ? 'up' : 'down'}`} />
                                    </svg>
                                </div>
                            </div>


                            {showDetails && (
                                <div className="risks__details risks-details _visible">
                                    {risks.map(risk => (
                                        <div className="risks-details__item risks-details-item" key={risk.id}>
                                            <div className="risks-details-item__inner">
                                                <div className="risks-details-item__left">
                                                    <div className="risk-card-more risk-card-more_flex">
                                                        <img className="svg-icon risk-card__icon" src={risk.icon} />
                                                        Риск <div className={getTagClass(risk.level)}>
                                                        {risk.level === 'high' ? 'Высокий' : risk.level === 'middle' ? 'Средний' : 'Низкий'}
                                                    </div>
                                                    </div>
                                                    <h6 className="risks-details-item__title">{risk.title}</h6>
                                                </div>
                                                <div className="risks-details-item__right">
                                                    <div className="text risks-details-item__text">
                                                        <p>{risk.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </section>
                <section className="section layout__section recommendations">
                    <div className="container">
                        <div className="section__content">
                            <div className="recommendations__inner">
                                <div className="recommendations__left">
                                    <div className="recommendations__element recommendations-element">
                                        <div className="recommendations-element__inner">
                                            <span
                                                className="recommendations-element__label">Как улучшить свое здоровье?</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="recommendations__right">
                                    <div className="recommendations__info">
                                        <h2 className="title recommendations__title">Рекомендации</h2>
                                        <p className="recommendations__description">
                                            Мы - специалисты LAB4U, медицинской онлайн-лаборатории.</p>
                                        <div className="text recommendations__text">
                                            <p>
                                                Даем возможность людям управлять здоровьем в современном темпе жизни:
                                                запись и
                                                оплата на сайте, сдача биоматериала в широкой сети партнерских центров и
                                                максимальная автоматизация обработки ваших анализов. Профилактика с
                                                LAB4U - это
                                                выгодно и удобно. На основе нашего 10-летнего опыта был разработан тест,
                                                который
                                                поможет выявить риски заболеваний.
                                                Сервис проанализирует ваши возможные риски и сформирует 3 блока
                                                рекомендаций:
                                                программу тренировок, здоровое меню и список необходимых микроэлементов
                                                для
                                                достижения ваших здоровых целей.
                                            </p><h5>С помощью генеративной нейросети мы подготовим план рекомендаций на
                                            4 недели с
                                            трекингом привычек на каждый день. Вы будете ежедневно отмечать свои успехи
                                            и
                                            следить за прогрессом.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="section layout__section neural-network">
                    <div className="container">
                        <header className="section__header section__header_center">
                            <h2 className="title section__title">Нейросеть здорового образа жизни</h2>
                        </header>
                        <div className="section__content">
                            <div className="neural-network__intro neural-network-intro">
                                <div className="neural-network-intro__inner">
                                    <div className="neural-network-intro__left">
                                        <div className="text neural-network-intro__text">
                                            <h5>Онлайн дневник с результатами, персональными рекомендациями, заданиями и
                                                аналитикой поможет тебе вести здоровый образ жизни.</h5>
                                            <p>
                                                Вы сможете снизить риски заболеваний, если будете следовать
                                                разработанным
                                                индивидуально для вас программам тренировок и питания. Нейросеть будет
                                                запоминать ваши результаты и с каждым месяцем лучше адаптировать
                                                программы для
                                                максимальной эффективности. </p>
                                        </div>
                                    </div>
                                    <div className="neural-network-intro__right">
                                        <div className="neural-network-intro__image-wrapper">
                                            <img className="neural-network-intro__image"
                                                 src="/img/test-result-img.png"
                                                 alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="neural-network__cards neural-network-cards">
                                <div className="neural-network-cards__grid">
                                    <div className="neural-network-cards__col">
                                        <div className="neural-network-card">
                                            <div className="neural-network-card__image-wrapper">
                                                <img className="neural-network-card__image"
                                                     src="/img/neural-network-card-image1.png"
                                                     alt="Индивидуальная программа физических упражнений"/>
                                            </div>
                                            <h3 className="neural-network-card__title">Индивидуальная программа
                                                физических
                                                упражнений</h3>
                                        </div>
                                    </div>
                                    <div className="neural-network-cards__col">
                                        <div className="neural-network-card">
                                            <div className="neural-network-card__image-wrapper">
                                                <img className="neural-network-card__image"
                                                     src="/img/neural-network-card-image2.png"
                                                     alt="Подобранная диета с учетом пройденного теста"/>
                                            </div>
                                            <h3 className="neural-network-card__title">Подобранная диета с учетом
                                                пройденного
                                                теста</h3>
                                        </div>
                                    </div>
                                    <div className="neural-network-cards__col">
                                        <div className="neural-network-card">
                                            <div className="neural-network-card__image-wrapper">
                                                <img className="neural-network-card__image"
                                                     src="/img/neural-network-card-image3.png"
                                                     alt="Персональная подборка витаминов и минералов от проверенных брендов"/>
                                            </div>
                                            <h3 className="neural-network-card__title">Персональная подборка витаминов и
                                                минералов
                                                от проверенных брендов</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <ScrollToTopButton />
            </main>
        </>
    );
};
